module.exports = "/_next/static/images/b99ece8cffb31000d6bcdb619b16a26a-david-mobile.jpg";